/** Тексты пространства «character». Ключи именуются по смыслу, а не по месту. */
export const character = {
  title: {
    hub: 'Мой персонаж',
  },

  /* ── Хаб «Мой персонаж»: состояние анкеты ───────────────────────────────── */

  status: {
    none: {
      title: 'Персонажа ещё нет',
      text: 'Заведите персонажа — и откроется анкета, склад, питомцы и способности. Анкету можно заполнять сколько угодно долго: черновик лежит на сервере, а на проверку он уходит отдельной кнопкой.',
    },
    /** Архивный занимает слот: объяснение вместо кнопки «завести». */
    archived: {
      title: 'Персонажа убрала администрация',
      text: 'В реестре его больше нет, а анкета, склад, питомцы и способности отсюда не открываются, хотя и не удалены. Нового персонажа, пока этот в архиве, не завести: на аккаунт положен один, и архивный по-прежнему занимает это место. Если это недоразумение, напишите администрации в сообщения сообщества и назовите номер персонажа — он вверху экрана. Удалить персонажа насовсем — вместе с анкетой и имуществом — можно и без администрации: вкладка «Ещё», раздел «Удалить мои данные». Право записи при этом снимется; вернуться в проект и завести нового персонажа можно будет самим, если открыта самостоятельная запись, иначе — через администрацию.',
    },
    empty: {
      title: 'Анкеты пока нет',
      text: 'Одиннадцать пунктов о персонаже: имя, внешность, характер, биография. Заполняется в любом порядке, черновик лежит на сервере — можно уйти на середине и вернуться завтра.',
    },
    rejected: {
      text: 'Модератор его не видит: черновик лежит только у вас. Пока не нажмёте «Отправить на проверку», в реестре персонажа не будет.',
    },
    pending: {
      text: 'Править её можно и сейчас: правки уходят в ту же заявку, но она возвращается в конец очереди.',
    },
    published: {
      text: 'Правки снова пойдут через проверку — до решения модератора в реестре останется нынешняя версия.',
    },
    /** Принятая версия в реестре, а поверх неё уже лежит правка. */
    both: {
      pending: 'Пока модератор их не принял, читатели видят прошлую принятую версию.',
      draft: 'Правки лежат в черновике и никуда не ушли. Читатели видят прошлую принятую версию.',
    },
  },

  badge: {
    draft: 'черновик',
    approved: 'принята',
    rejected: 'отклонена',
    editInFlight: 'правка в пути',
    unpublished: 'не опубликована',
    request: 'заявка',
    requestPending: 'заявка на проверке',
  },

  mark: {
    published: 'опубликована',
  },

  meta: {
    version: 'версия {{no}}',
    editedAt: 'правка {{date}}',
    submittedAt: 'отправлена {{date}}',
    notSubmitted: 'не отправлялась',
    rejectedAt: 'отказ {{date}}',
    publishedSince: 'в реестре с {{date}}',
    archivedAt: 'убран {{date}}',
  },

  notice: {
    publishedHeldAfterReject: 'В реестре держится версия {{no}} — отказ её не снял.',
  },

  action: {
    create: 'Завести персонажа',
    fill: 'Заполнить анкету',
    submit: 'Отправить на проверку',
    submitEdits: 'Отправить правки на проверку',
    continueForm: 'Дописать анкету',
    continueEdits: 'Дописать правки',
    editForm: 'Править анкету',
    editRequest: 'Править заявку',
    fixAndResubmit: 'Исправить и отправить заново',
    openCard: 'В реестр',
  },

  toast: {
    submitted: 'Заявка ушла на проверку',
  },

  error: {
    loadFailed: 'Не получилось загрузить',
  },

  /* ── Разделы хаба и история версий ──────────────────────────────────────── */

  section: {
    property: 'Имущество',
    history: 'История анкеты',
  },

  nav: {
    inventory: { hint: 'предметы, метки и заявки' },
    pets: { hint: 'клички, паспорта и заявки' },
    abilities: {
      title: 'Способности и дебафы',
      hint: 'способности и дебафы, полученные в игре',
      hintCount: 'в анкете {{value}}',
    },
    decisions: {
      title: 'Решения модерации',
      hint: 'вердикты по моим заявкам',
    },
  },

  history: {
    empty: {
      title: 'Версий пока нет',
      text: 'Здесь встанут все версии анкеты: когда отправлены, что решил модератор и какая из них сейчас в реестре.',
    },
    version: 'Версия {{no}}',
  },

  empty: {
    noDecision: 'Решения пока нет',
  },

  moderator: {
    noComment: 'Модератор не оставил комментарий — спросите у него напрямую.',
  },

  /** Метки в шапке карточки персонажа: их ставит модератор, игрок не правит. */
  facts: {
    noDorm: 'общежитие не назначено',
    dormless: 'без общежития',
    classUnassigned: 'класс не назначен',
    studyClass: 'Класс {{value}}',
  },

  /* ── Гость: персонажа ещё не завели или запись закрыли ──────────────────── */

  guest: {
    banner: {
      noAccess: 'доступа нет',
      join: 'запись открыта',
      deleted: 'данные удалены',
    },
    title: {
      readOnly: 'Запись закрыта',
      noAccess: 'Своя анкета вам пока недоступна',
      join: 'Присоединяйтесь к проекту',
      rejoin: 'Можно вернуться в проект',
      deleted: 'Вы удалили свои данные',
    },
    text: {
      readOnly:
        'Читать можно всё как раньше: реестр, карточки персонажей, базу внешек. А вот отправлять анкету и вести склад — уже нет: право записи сняла администрация или вы сами удалили свои данные. Чтобы его вернуть, напишите администрации.',
      noAccess:
        'Читать можно всё: реестр персонажей, их карточки, склад, питомцев и базу внешек — для этого ничего делать не нужно. Своя анкета появится, когда администратор добавит вашу страницу в список участников. Если доступ у вас был и его сняли, персонаж и всё, что вы внесли, остаются в приложении — удалить их можно во вкладке «Ещё», в разделе «Удалить мои данные».',
      join: 'Читать можно всё и без этого: реестр персонажей, их карточки, склад, питомцев и базу внешек. А чтобы завести своего персонажа, сейчас достаточно нажать кнопку — администратор для этого не нужен.',
      rejoin:
        'Вы удалили свои данные: персонажа с анкетой и имуществом больше нет, право записи снято. Читать реестр, карточки персонажей и базу внешек можно как раньше. Запись в проект сейчас открыта, так что вернуться можно самим — кнопкой ниже, без администратора.',
      deleted:
        'Персонажа с анкетой и имуществом больше нет, право записи снято. Читать реестр, карточки персонажей и базу внешек можно как раньше. Самостоятельная запись сейчас закрыта — чтобы вернуться, напишите администрации. Если запись откроют, здесь появится кнопка «Присоединиться».',
    },
    section: {
      open: 'Что открыто сейчас',
      howToGet: 'Как получить доступ',
      howToReturn: 'Как вернуть доступ',
      vkId: 'Ваш номер страницы',
      join: 'Свой персонаж',
    },
    action: {
      registry: 'Реестр',
      faces: 'База внешек',
      join: 'Присоединиться',
    },
    step: {
      write: {
        title: 'Напишите администрации проекта',
        hint: 'Через сообщения сообщества — это единственный путь, кнопки «подать заявку» здесь нет',
      },
      id: {
        title: 'Назовите номер своей страницы',
        hint: 'Администратор ищет по нему: короткое имя вы можете сменить, а номер останется тот же',
      },
      wait: {
        title: 'Дождитесь, пока вас добавят',
        hint: 'После этого вкладка «Персонаж» откроется сама — приложение достаточно перезапустить',
      },
    },
    vkIdHint:
      'Внутренний номер вашей страницы ВКонтакте. Перешлите его администратору — по нему вас и добавят.',

    join: {
      hint: 'В список участников вас запишут под именем страницы ВКонтакте. Дальше своя анкета: заполняете сами, проверяет модератор.',
      hintReturn:
        'Право записи вернётся сразу, имя в списке участников обновится по странице ВКонтакте. Прежнего персонажа не восстановить: анкету заполняете заново, проверяет модератор.',
      failed: 'Не получилось',
      revoked:
        'Доступ к этому аккаунту сняла администрация. Вернуть его самостоятельно нельзя — напишите в сообщения сообщества. Удалить персонажа и свои данные можно и без этого: вкладка «Ещё», раздел «Удалить мои данные».',
      already: 'Ваша страница уже в списке участников. Перезапустите приложение.',
      closed: 'Запись только что закрыли. Напишите администрации — вас добавят руками.',
    },
  },

  /* ── Редактор анкеты ────────────────────────────────────────────────────── */

  editor: {
    section: {
      names: 'Имена и обращение',
      appearance: 'Внешность',
      personality: 'Характер и биография',
      family: 'Семья',
      misc: 'Прочее',
    },
    placeholder: {
      nameRu: 'Как персонажа зовут по документам',
      nicknames: 'Как к нему обращаются',
      abilityDescription: 'Что умеет, чего не умеет и чем даётся',
    },
    hint: {
      appearanceImage:
        'Уедет на проверку вместе с анкетой. В реестре показывается снимок принятой версии.',
      age: 'Можно словами: «около двадцати» — тоже ответ',
      race: 'Свободный ввод: спорные варианты смотрит модератор',
      abilitiesUsed: 'Занято {{used}} из {{max}}.',
    },
    action: {
      saveEdit: 'Сохранить правку',
      saveDraft: 'Сохранить черновик',
      addAbility: 'Ещё способность',
      removeAbility: 'Убрать способность {{n}}',
    },
    error: {
      loadTitle: 'Не получилось открыть анкету',
      saving: 'Черновик ещё сохраняется. Попробуйте через секунду.',
    },
    /** Выход с несохранённым текстом: вопрос, а не молчаливое действие. */
    leave: {
      saveEditTitle: 'Сохранить правку?',
      saveDraftTitle: 'Сохранить черновик?',
      errorTitle: 'Правка не сохранилась',
      pendingText:
        'Вы что-то изменили в анкете. Правка уйдёт в ту же заявку, и она вернётся в конец очереди. Не сохраните — правка пропадёт.',
      draftText:
        'Вы что-то изменили в анкете. Черновик виден только вам — на проверку он не уходит, пока не нажмёте «Отправить».',
      discard: 'Удалить изменения',
      leaveAnyway: 'Выйти, потеряв правки',
    },
  },

  /* ── «Что изменилось»: экран сравнения и его поля ───────────────────────── */

  diff: {
    title: 'Что изменилось',
    section: {
      changes: 'Правки',
    },
    hint: {
      first:
        'Так анкету увидит модератор. Сравнение собирает сервер: у него оба текста приведены к одному виду.',
      compare:
        'Сверху — то, что сейчас в реестре, снизу — то, что уедет модератору. Сравнение собирает сервер: у него оба текста приведены к одному виду, и «было» со «стало» не разъедутся на лишнем пробеле.',
    },
    empty: {
      noOpen: {
        title: 'Правок нет',
        text: 'В работе сейчас ничего не лежит.',
      },
      noBase: {
        title: 'Анкета пока пустая',
        text: 'Сравнивать не с чем.',
      },
      same: {
        title: 'Отличий нет',
        text: 'Правка совпадает с принятой версией.',
      },
    },
    notice: {
      untilApproved: 'Пока правку не примут, в реестре держится принятая версия.',
    },
    label: {
      before: 'Было',
      after: 'Стало',
      published: 'В реестре',
      newVersion: 'В новой версии',
    },
    badge: {
      changed: 'изменено',
    },
    value: {
      empty: 'не заполнено',
      noPhoto: 'фото нет',
      photo: 'фото',
      blank: 'Пусто',
    },
  },

  /* ── Персонажи глазами администрации ────────────────────────────────────── */

  admin: {
    listTitle: 'Персонажи · {{total}}',
    fallbackName: 'Персонаж {{no}}',
    openLabel: 'Открыть персонажа: {{name}}',
    filter: {
      state: 'Состояние',
      dorm: 'Общежитие',
      active: 'В реестре',
      archived: 'В архиве',
      noDorm: 'Без общежития',
    },
    empty: {
      title: 'Никого не нашли',
      text: 'По выбранным условиям персонажей нет.',
    },
    section: {
      fields: 'Админские поля',
      transfer: 'Передать другому аккаунту',
      archive: 'Архив и удаление',
    },
    field: {
      owner: 'Владелец',
      formStatus: 'Состояние анкеты',
      publishedAt: 'Опубликован',
      kind: 'Кто он в Мезе',
      dorm: 'Общежитие',
      studyClass: 'Класс',
      transferTo: 'Числовой id новой страницы ВК',
      reason: 'Причина',
      archivedAt: 'В архиве с',
      archiveReason: 'Причина архива',
    },
    placeholder: {
      dormEmpty: 'Не назначено',
      classEmpty: 'Не назначен',
      vkId: '123456789',
      reason: 'Например: потерян доступ к прежней странице',
      archiveReason: 'Например: игрок покинул проект',
    },
    hint: {
      kind: 'Сотрудник, житель или преподаватель. Выпускник из этого не выводится — он считается по классу.',
      dorm: 'Игрок это поле не заполняет. Без общежития анкету персонажа принять нельзя.',
      studyClass: 'Тоже админское поле, ставится по итогам оценки.',
      cantUnset:
        'Снять уже назначенное общежитие или класс здесь нельзя — их можно только заменить другим значением.',
      transferTo:
        'Обычный случай: игрок потерял доступ к странице и завёл новую. Аккаунт-получатель должен уже быть в списке участников, иметь право записи и свободный слот, иначе сервер откажет.',
      reason: 'Попадёт в журнал: через полгода никто не вспомнит, почему передали.',
      archiveReason: 'Необязательно. Её увидит администрация в карточке персонажа.',
    },
    /** Пробел и тире в начале: строка дописывается к имени владельца. */
    accessRevoked: ' — доступ снят',
    noForm: 'Анкеты ещё нет',
    noArchiveReason: 'не указана',
    transferred: 'Персонаж передан новому аккаунту.',
    archivedDone: 'Персонаж убран в архив.',
    purged: 'Персонаж удалён.',
    error: {
      title: 'Не получилось',
      digitsOnly: 'Только цифры.',
    },
    action: {
      transfer: 'Передать персонажа',
      archive: 'В архив',
      purge: 'Удалить насовсем',
    },
    confirm: {
      transfer: {
        title: 'Передать персонажа?',
        text: 'Персонаж уйдёт аккаунту id {{id}}. Авторство прошлых версий анкеты не переписывается: это история, а не владение.',
        confirm: 'Передать',
      },
      archive: {
        title: 'Убрать персонажа в архив?',
        text: 'Персонаж пропадёт из реестра, а игрок увидит в кабинете лишь отметку «в архиве» с датой — причину ему не покажут. Анкета, склад, питомцы и способности сохранятся. Вернуть его из архива пока нельзя, а нового персонажа игрок не заведёт, пока слот аккаунта занят архивным. Освободить слот игрок может и сам — удалив свои данные вместе с архивным персонажем; если открыта самостоятельная запись, после этого он вернётся в проект без администрации и заведёт персонажа заново.',
        confirm: 'В архив',
      },
      purge: {
        title: 'Удалить персонажа насовсем?',
        text: 'Анкета со всеми версиями, склад, питомцы и способности удалятся безвозвратно — резервной копии нет. История решений модерации останется, но без ссылки на персонажа. Слот аккаунта освободится.',
        confirm: 'Удалить',
      },
    },
  },
} as const;
